import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ITranslatedText, ITranslationSettings } from '@dxp/core/models';
import { Observable } from 'rxjs';
import { environment } from '@dxp/core/environment';
import { LOGGER_REQUEST_NAME } from '@dxp/core/types';

@Injectable({
    providedIn: 'root',
})
export class TranslationApiService {
    readonly #http = inject(HttpClient);

    getSettings(): Observable<ITranslationSettings> {
        return this.#http.get<ITranslationSettings>(
            `${environment.translationUrl}/text/setting`,
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Translation Service (Get Setings)',
                ),
            },
        );
    }

    translateFromForeign(
        channelId: number,
        targetLanguage: string,
        texts: string[],
    ): Observable<ITranslatedText> {
        return this.#http.post<ITranslatedText>(
            `${environment.translationUrl}/text/from/channels/${channelId}`,
            {
                targetLang: targetLanguage,
                texts,
            },
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Translation Service (Translate From Foreign)',
                ),
            },
        );
    }

    translateToForeign(
        channelId: number,
        sourceLanguage: string,
        targetLanguage: string,
        texts: string[],
    ): Observable<ITranslatedText> {
        return this.#http.post<ITranslatedText>(
            `${environment.translationUrl}/text/to/channels/${channelId}`,
            {
                sourceLang: sourceLanguage.split('-')[0],
                fallbackTargetLang: targetLanguage,
                texts,
            },
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Translation Service (Translate To Foreign)',
                ),
            },
        );
    }
}
